


export enum IAnalyticsEvents {
  SessionStart = 'session_start',
  SignIn = 'sign_in',
  Purchase = 'purchase',
  ViewItems = 'view_items',
  ViewItemDetails = 'view_item',
  BeginCheckout = 'begin_checkout',
  PaymentInformation = 'add_payment_info',
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
}


/**
 * trackEvent is a generic function to trigger events on both:
 * 1) Meta Pixel (using trackCustom or track for standard events)
 * 2) GA4 (using gtag('event', ...))
 *
 * @param eventName - The event name, typically from AnalyticsEvents
 * @param eventParams - Additional data you want to include
 */
export function trackEvent(
  eventName: IAnalyticsEvents,
  eventParams: Record<string, any>
): void {
  if (typeof window !== 'undefined' && (window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: eventName,
      ...eventParams,
    });
    console.log('Event pushed to dataLayer:', eventName, eventParams);
  } else {
    console.error('dataLayer is not available.');
  }
}